const avatarColors = {
    muac: {
      green: 'var(--success)',
      yellow: 'var(--caution)',
      orange: 'var(--warning)',
      red: 'var(--danger)',
      unknown: 'var(--primary-blue-10)',
    },
    pale_eyelids: {
      yes: 'var(--pale-eyelids)',
      no: 'var(--healthy-eyelids)',
      unknown: 'var(--primary-blue-10)',
    },
  }

const panelsWithAvatars = ['muac', 'pale_eyelids',]

const playbackRates = {
  capillary_refill: {
    normal: 1.0,
    less: 0.5,
    much_less: 0.25,
  },
  skin_turgor: {
    normal: 1,
    less: 0.5,
    much_less: 0.3,
  }
}

export default {
  methods: {
    cardClass() {
      // special case - patient uuid gets assigned on track panel but panel should always have intro-dark theme, and user preferences can
      // be accessed after uuid assignment
      if (['Track', 'Preference', 'Location'].includes(this.$router.currentRoute.name)) {
        return "intro-dark"
      } else {
        let patientUuid = this.$store.getters["v4/session/details"]().patient.uuid

        if (!patientUuid) {
          return 'intro-dark'
        } else {
          return 'assessment-light rounded-b-0'
        }
      }
    },
    isMobileDevice() {
      // snippet from Timothy Huang
      return(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
    // calculates the amount of space allowed for the main component
    maxHeight(offset) {
      let vh = window.innerHeight
      return vh - offset
    },
    panelHasColorAvatar(panelName) {
      return panelsWithAvatars.includes(panelName)
    },
    getAvatarColor(panelName, responseValue) {
      return avatarColors[panelName][responseValue]
    },
    getPlaybackRate(panelName, responseValue) {
      return playbackRates?.[panelName]?.[responseValue] || 1.0
    },
  },
}
